export class Group {
    constructor(group) {
        {
            this.groupID = group.groupID;
            this.ownerID = group.ownerID;
            this.companyID = group.companyID;
            this.createDate = group.createDate;
            this.disabled = group.disabled;
            this.name = group.name || '';
            this.userCount = group.userCount || '';
            this.userList = group.userList || [];
            this.groupType = group.groupType;
            this.allUserSelected = group.allUserSelected;
            this.selectedUserCount = group.selectedUserCount;
            this.favorite = group.favorite;
        }
    }
}
//# sourceMappingURL=group.model.js.map